// src/components/Spinner.tsx
'use client';

export default function CWSpinner({ size = 94 }: { size?: number }) {
  return (
    <div
      className="mx-auto flex items-center justify-center text-ais-green"
      style={{ width: size, height: size }}
    >
      <svg
        className="animate-spin"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="32"
          cy="32"
          r="28"
          stroke="currentColor"
          strokeWidth="8"
          opacity="0.2"
        />
        <path
          d="M32 4a28 28 0 1 1-28 28"
          stroke="currentColor"
          strokeWidth="8"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}
